"use client";

var __jsx = React.createElement;
import React, { useEffect } from 'react';
import useErrorsManagement from '@lib/hooks/use-errors-management';
import { UnauthorizedError } from '@lib/errors/unauthorized.error';
import ERROR_CODES from '@lib/error-codes';
const NextErrorScreen = _ref => {
  let {
    error,
    reset
  } = _ref;
  const {
    manageSharedError
  } = useErrorsManagement();
  useEffect(() => {
    if (error instanceof UnauthorizedError) {
      manageSharedError(ERROR_CODES.Shared.UNAUTHORIZED_ERROR);
    } else {
      manageSharedError(ERROR_CODES.Shared.UNKNOWN_ERROR, true);
    }
  }, []);
  return __jsx("div", {
    className: "flex w-full h-full"
  });
};
export default NextErrorScreen;